import BuildIcon from "@mui/icons-material/Build";
import { Button, CircularProgress, Stack } from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";
import { useStripeCustomerBillingPortal, useSubscriptionStatus } from "hooks";
import { canOpenStripeBillingPortal } from "utils/subscription";

export function ManageSubscriptionButton() {
  const { loading, error, requestCustomerBillingPortalSession } =
    useStripeCustomerBillingPortal({
      onSessionCreatedSuccess: (url) => {
        window.open(url, "_self");
      },
    });

  const { subscription } = useSubscriptionStatus();

  const onButtonClicked = () => {
    requestCustomerBillingPortalSession();
  };

  if (!subscription) {
    return null;
  }

  if (!canOpenStripeBillingPortal(subscription)) {
    return null;
  }

  return (
    <Stack direction="column">
      <Button
        variant="outlined"
        size="small"
        onClick={onButtonClicked}
        endIcon={loading ? <CircularProgress /> : <BuildIcon />}
        disabled={loading}
      >
        {subscription.subscription_plan === "CARRIER_PAY_PER_BOOKING"
          ? "Manage Billing"
          : "Manage Subscription"}
      </Button>
      <ErrorTypography error={error} />
    </Stack>
  );
}
